import React, { memo } from "react";
import { VersionInfoProps } from "./types";

export const VersionInfo: React.FC<VersionInfoProps> = memo(
  ({ versionInfo }) => {
    if (!versionInfo || (versionInfo.current === 1 && versionInfo.total <= 1))
      return null;

    if (!versionInfo.total)
      return <div className="h-4 w-20 animate-pulse rounded bg-gray-50"></div>;

    return (
      <>
        <div className="h-1 w-1 rounded-full bg-gray-300"></div>
        <span className="text-sm text-gray-600">
          Version {versionInfo.current} of {versionInfo.total}
        </span>
      </>
    );
  },
);
